import React, { useEffect } from "react";

const client = [
  {
    img: "Sources/images/logos/prepseed.png",
  },
  {
    img: "Sources/images/logos/chartered.png",
  },
  {
    img: "Sources/images/logos/craftezy.png",
  },
  {
    img: "Sources/images/logos/shivtex.png",
  },
  {
    img: "Sources/images/logos/rdt.png",
  },
  {
    img: "Sources/images/logos/cidroy.png",
  },

  {
    img: "Sources/images/logos/adira.png",
  },
  {
    img: "Sources/images/logos/drashti.png",
  },
  {
    img: "Sources/images/logos/FA.png",
  },
  {
    img: "Sources/images/logos/Bim.png",
  },
  {
    img: "Sources/images/cardinal.png",
  },
  {
    img: 'Sources/images/logos/digvijay.png',
  },
  {
    img: "Sources/images/logos/64.png",
  },
  {
    img: "Sources/images/logos/adrija.png",
  },
  {
    img: "Sources/images/logos/age.png",
  },
  {
    img: "Sources/images/logos/archbude.png",
  }
  ,
  {
    img: "Sources/images/logos/bbg.png",
  },
  {
    img: "Sources/images/logos/beacon.png",
  },
  {
    img: "Sources/images/logos/biochem.png",
  },
  {
    img: "Sources/images/logos/bluefire.png",
  },
  {
    img: "Sources/images/logos/Bsquare.png",
  }
  ,
  {
    img: "Sources/images/logos/hitech.png",
  },
  {
    img: "Sources/images/logos/ninefive.png",
  },
  {
    img: "Sources/images/logos/qutone.png",
  },
  {
    img: "Sources/images/logos/book.png",
  },
  {
    img: "Sources/images/logos/braincuber.png",
  },
  {
    img: "Sources/images/logos/codertrails.png",
  },

  // {
  //   img: "Sources/images/logos/bsquare.png",
  // },
  {
    img: "Sources/images/logos/enable.png",
  },
  {
    img: "Sources/images/logos/estrella.png"
  },
  {
    img: "Sources/images/logos/finanvo.png",
  },
  {
    img: "Sources/images/logos/gloline.png",
  },
  {
    img: "Sources/images/logos/gramvaani.png",
  },
  {
    img: "Sources/images/logos/h4healing.png",
  },
  {
    img: "Sources/images/logos/happick.png",
  },
  {
    img: "Sources/images/logos/inspire.png",
  },
  {
    img: "Sources/images/logos/maak.png",
  },
  {
    img: "Sources/images/logos/mandir.png",
  },
  {
    img: "Sources/images/logos/mastersoft.png",
  },
  {
    img: "Sources/images/logos/online.png",
  },
  {
    img: "Sources/images/logos/pet.png",
  },
  {
    img: "Sources/images/logos/poas.png",
  },
  {
    img: "Sources/images/logos/savory.png",
  },
  {
    img: "Sources/images/logos/scones.png",
  },
  {
    img: "Sources/images/logos/shinkhan.png",
  },
  {
    img: "Sources/images/logos/simplso.png",
  },
  {
    img: "Sources/images/logos/softco.png",
  },
  {
    img: "Sources/images/logos/techmyntra.png",
  },
  {
    img: "Sources/images/logos/v.png",
  },
  {
    img: "Sources/images/logos/valuemize.png",
  },
  {
    img: "Sources/images/logos/KhushiLogo.JPG",
  },
  {
    img: "Sources/images/logos/Neutec.JPG",
  },
  {
    img: "Sources/images/logos/FR.JPG",
  },
  {
    img: "Sources/images/logos/Divya.JPG",
  },
  {
    img: "Sources/images/logos/TDM.JPG",
  },
  {
    img: "Sources/images/logos/Vebbbeeeee.JPG",
  },
  {
    img: "Sources/images/logos/SUMS.JPG",
  },
  {
    img: "Sources/images/logos/DYD.JPG",
  },
  {
    img: "Sources/images/logos/ClarityComm.JPG",
  },
  {
    img: "Sources/images/logos/AB Mittal.JPG",
  },
  {
    img: "Sources/images/logos/EximiusVenture.JPG",
  },
  {
    img: "Sources/images/logos/Fiable.JPG",
  },
  {
    img: "Sources/images/logos/yellowspot.JPG",
  },
  {
    img: "Sources/images/logos/Tribalvedda.JPG",
  },
  {
    img: "Sources/images/logos/Growth91.JPG",
  },
  {
    img: "Sources/images/logos/ITZEL.JPG",
  },
  {
    img: "Sources/images/logos/Tringular.JPG",
  },
  {
    img: "Sources/images/logos/Orget.JPG",
  },
  {
    img: "Sources/images/logos/ACE racquets.JPG",
  },
  {
    img: "Sources/images/logos/Happick.JPG",
  },
  {
    img: "Sources/images/logos/Gloline.JPG",
  },
  {
    img: "Sources/images/logos/Club.JPG",
  },
  {
    img: "Sources/images/logos/RMJ.JPG",
  },
  {
    img: "Sources/images/logos/Advisory.JPG",
  },
  {
    img: "Sources/images/logos/Tikkaow.JPG",
  },
  {
    img: "Sources/images/logos/Vibfast.JPG",
  },
  {
    img: "Sources/images/logos/AlmaShines.JPG",
  },
  {
    img: "Sources/images/logos/quickDraft.JPG",
  },
  {
    img: "Sources/images/logos/Proffestional Edge.JPG",
  },
  {
    img: "Sources/images/logos/H4Healing.JPG",
  },
  {
    img: "Sources/images/logos/Soul.JPG",
  },
  {
    img: "Sources/images/logos/Hyrespree.JPG",
  },
  {
    img: "Sources/images/logos/PBI.JPG",
  },
  {
    img: "Sources/images/logos/Tronsoft.JPG",
  },
  {
    img: "Sources/images/logos/risentech.JPG",
  },


];
const AllClients = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    scrollToTop(); // Call the function when the component mounts
  }, []);
  return (
    <>
      <div className="section_padding"></div>
      <div className="section_padding"></div>
      <div className="container section_padding">
        <div className="text-center mt-5 mb-5">

          <h2 className="title-section">Our<span className="marked"> Partners</span> </h2>
          <div className="divider mx-auto"></div>
        </div>
      </div>
      <section className="section section-default mt-none mb-none">
        <div className="container">
          {/* <h2 className="mb-sm">
                        Our <strong>Partners</strong>
                    </h2> */}
          <div className="row mb-5 w-100 client">
            {client.map((item, key) => {
              return (
                <>
                  <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6  p-2 ">
                    <img src={item.img} alt="" className="w-100 client_img" data-aos="fade-right"
                      data-aos-offset="100"
                      data-aos-easing="ease-in-sine" />
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};
export default AllClients;
